import StudentAccommodation from "./src/main";

/* istanbul ignore next */
StudentAccommodation.install = function (Vue) {
  Vue.component(StudentAccommodation.name, StudentAccommodation);
};

export default StudentAccommodation;
